import { render, staticRenderFns } from "./HonorSlotPC.vue?vue&type=template&id=ce3fd520&scoped=true"
import script from "./HonorSlotPC.vue?vue&type=script&lang=js"
export * from "./HonorSlotPC.vue?vue&type=script&lang=js"
import style0 from "./HonorSlotPC.vue?vue&type=style&index=0&id=ce3fd520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3fd520",
  null
  
)

export default component.exports